if (!customElements.get('collections-filtering')) {
	class CollectionsFiltering extends HTMLElement {
		constructor() {
			super();

			this.form = this.querySelector('form');
			this.button = this.querySelector('button[type="submit"]');
			this.select = this.querySelector('select.dropdown-collection');
			this.input = this.querySelector('input.input-collection');
			this.selects = this.querySelectorAll('select.dropdown-filter');

			this.setupEventListeners();

			// There's no collection dropdown so we either need to populate
			// the filters of the entire store or the single collection chosen
			// (if only one collection has been chosen).
			if (!this.select) {
				this.populateCollectionFilters(true);
			}
		}

		setupEventListeners() {
			this.form.addEventListener('submit', (event) => {
				event.preventDefault();
				window.location = this.form.getAttribute('action');
			});
			this.select?.addEventListener('change', this.onCollectionChange.bind(this));
			this.selects.forEach(event => {
				event.addEventListener('change', this.onFilterChange.bind(this));
			});
		}

		constructURL() {
			const collectionUrl = this.select?.value ?? this.input?.value ?? window.routes.all_products_url;
			const url = new URL(collectionUrl, window.requestShopUrl);

			this.querySelectorAll('select.dropdown-filter:enabled').forEach((select) => {
				if (select.value === "") {
					return;
				}

				Array.from(select.selectedOptions).forEach((option) => {
					url.searchParams.set(option.dataset.paramName, option.value);
				});
			});

			return url.toString();
		}

		setFormUrl(url, background) {
			this.form.setAttribute('action', url);

			// This operation happens on the background
			// where the user should not be notified of loading with spinners
			// etc.
			if (!background) {
				this.button.disabled = false;
			}
		}

		selectRemoveOptions(select) {
			const options = select.querySelectorAll('option:not(.default)');

			options.forEach((option) => {
				select.removeChild(option);
			});

			select.querySelector('option').selected = true;
		}

		onFilterChange(event) {
			const selectedIndex = event.target.dataset.index;

			this.selects.forEach((select) => {
				if (Number(select.dataset.index) <= Number(selectedIndex)) {
					return;
				}

				this.selectRemoveOptions(select);
				select.disabled = true;
				select.closest('.form-group').classList.add('disabled');
			});

			this.setFormUrl(this.constructURL());

			const url = new URL(this.constructURL());
			url.searchParams.set('view', 'do_not_use');
			this.toggleLoading();

			fetch(url)
				.then((response) => {
					if (!response.ok) {
						throw new Error(response.status);
					}

					return response.text();
				})
				.then((text) => {
					this.toggleLoading();
					const resultsMarkup = new DOMParser().parseFromString(text, 'text/html');

					this.selects.forEach((select) => {
						if (Number(select.dataset.index) <= Number(selectedIndex)) {
							return;
						}

						const options = resultsMarkup.querySelectorAll(`select[data-label="${select.dataset.label}"] option`);
						if (options.length > 0) {
							const availableOptions = Array.from(options).filter(option => Number(option.dataset.count) > 0);
availableOptions.forEach(option => {
    option.textContent = option.textContent.replace(/\s*\(\d+\)\s*$/, '');
});
select.append(...availableOptions);
							select.querySelector('option.default').selected = true;
						}

						if (Number(select.dataset.index) === Number(selectedIndex) + 1) {
							select.disabled = false;
							select.closest('.form-group').classList.remove('disabled');
						}
					});

					// Quand les versions sont lues sur les produits (et non sur les
					// filtres natifs plafonnes a 100), la page ne contient que les 50
					// premiers produits : on ramene les pages suivantes s'il y en a.
					const paged = resultsMarkup.querySelector('select[data-source="products"][data-next-page]');
					if (paged) {
						const target = Array.from(this.selects).find((s) => s.dataset.label === paged.dataset.label);
						if (target) {
							this.appendRemainingPages(url.toString(), paged.dataset.label, target, Number(paged.dataset.nextPage));
						}
					}
				})
				.catch((error) => {
					throw error;
				});
		}

		// Les options ramenees des pages suivantes arrivent apres celles de la
		// page 1 : on retrie l'ensemble sur la cle chronologique du serveur.
		resortByKey(select) {
			const options = Array.from(select.options).filter((option) => option.dataset.sortkey);
			if (options.length < 2) {
				return;
			}

			options.sort((a, b) => a.dataset.sortkey.localeCompare(b.dataset.sortkey));
			options.forEach((option) => select.append(option));
		}

		appendRemainingPages(baseUrl, label, select, page) {
			if (!page || page > 50) {
				return;
			}

			const url = new URL(baseUrl);
			url.searchParams.set('page', page);

			fetch(url)
				.then((response) => {
					if (!response.ok) {
						throw new Error(response.status);
					}

					return response.text();
				})
				.then((text) => {
					const doc = new DOMParser().parseFromString(text, 'text/html');
					const source = doc.querySelector(`select[data-label="${label}"]`);
					if (!source) {
						return;
					}

					const existing = new Set(Array.from(select.options).map((option) => option.value));
					const extra = Array.from(source.querySelectorAll('option'))
						.filter((option) => Number(option.dataset.count) > 0 && !existing.has(option.value));

					extra.forEach((option) => {
						option.textContent = option.textContent.replace(/\s*\(\d+\)\s*$/, '');
					});

					select.append(...extra);
					this.resortByKey(select);

					if (source.dataset.nextPage) {
						this.appendRemainingPages(baseUrl, label, select, Number(source.dataset.nextPage));
					}
				})
				.catch(() => {});
		}

populateCollectionFilters(background = false) {
    this.setFormUrl(this.constructURL(), background);

    const url = new URL(this.constructURL());
    url.searchParams.set('view', 'do_not_use');

    // When we initially populate the filters we don't want
    // to show a loading spinner.
    if (!background) {
        this.toggleLoading();
    }

    fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw new Error(response.status);
            }

            return response.text();
        })
        .then((text) => {
            if (!background) {
                this.toggleLoading();
            }

            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html');

            this.selects.forEach((select) => {
                const options = resultsMarkup.querySelectorAll(`select[data-label="${select.dataset.label}"] option`);
                if (options.length > 0) {
                    Array.from(options).forEach(option => {
                        option.textContent = option.textContent.replace(/\s*\(\d+\)\s*$/, '');
                    });
                    select.append(...options);
                    select.querySelector('option.default').selected = true;
                }

                if (Number(select.dataset.index) === 1) {
                    select.disabled = false;
                    select.closest('.form-group').classList.remove('disabled');
                }
            });
        })
        .catch((error) => {
            throw error;
        });
}


		onCollectionChange() {
			this.selects.forEach((select) => {
				this.selectRemoveOptions(select);
				select.disabled = true;
				select.closest('.form-group').classList.add('disabled');
			});

			this.populateCollectionFilters();
		}

		toggleLoading() {
			this.classList.toggle('is-loading');
			this.button.classList.toggle('loading');
		}
	}

	customElements.define('collections-filtering', CollectionsFiltering);
}